import { URL_REPLACEMENT } from '$const';
import { patch } from '~services/api/methods';

export async function patchChangelogItem(id: ChangelogItem['id'], description: ChangelogItem['description']) {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/ebm/changelog/items/${id}`;
  const response = await patch<boolean, { description: string }>(requestUrl, { description });
  return response;
}
